// extracted by mini-css-extract-plugin
export default {"tx":"Bottomone_tx__7vNzV","txwho":"Bottomone_txwho__qtCWx","txdes":"Bottomone_txdes__m2p3T"};